var _defs, _sodipodNamedview, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCargo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "380.20001mm",
    height: "260.79999mm",
    viewBox: "0 0 380.20001 260.79999",
    id: "svg4943",
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    sodipodiDocname: "cargo_nobg.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4937"
  })), _sodipodNamedview || (_sodipodNamedview = /*#__PURE__*/React.createElement("sodipodNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 0.35355339,
    inkscapeCx: -1261.9835,
    inkscapeCy: -136.71586,
    "inkscapeDocument-units": "mm",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "false",
    "inkscapeWindow-width": 3840,
    "inkscapeWindow-height": 2050,
    "inkscapeWindow-x": -12,
    "inkscapeWindow-y": -12,
    "inkscapeWindow-maximized": 1
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4940"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Calque 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(0,-36.197936)"
  }, /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4692",
    d: "M 67.759058,208.66281 C 52.244623,198.22575 26.171854,197.80469 26.171854,197.80469 c 35.09094,-34.13184 19.4858,-65.02457 19.4858,-65.02457 0,0 35.110824,4.87869 27.621814,40.82199 0,0 -7.315804,-4.33035 -14.973776,-2.12846 0,0 8.533089,10.42184 9.453366,37.18916 z",
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccccccccccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4694",
    d: "m 144.97826,255.78903 h 71.97621 l 12.36492,-14.64875 h 58.44728 c 0,12.71515 15.26402,11.7483 15.26402,11.7483 16.31873,0 19.95159,-8.17402 19.95159,-8.17402 l 3.75009,1.99225 c -7.96887,20.03952 -38.32112,33.64723 -38.32112,33.64723 -9.44912,3.86949 -11.13316,12.53935 -11.13316,12.53935 H 63.648257 c -0.0579,-9.25805 -7.031523,-13.00813 -7.031523,-13.00813 -12.715393,-9.08224 -11.132965,-25.50251 -11.132965,-25.50251 l 1.289082,-23.67246 h 86.369189 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 2.62467504,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4696",
    d: "m 300.64445,154.64636 c 0,0 10.77092,32.6547 0.79802,64.51155 0,0 24.5051,-8.83327 55.62111,-0.91178 0,0 -30.37511,-49.01061 -56.41913,-63.59979 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4698",
    d: "m 228.54202,191.66585 c 0,0 8.71933,12.9935 3.07743,39.72134 0,0 35.95072,-16.51873 65.76539,-1.42471 0,0 6.72467,-27.4687 -8.32041,-43.25465 0,0 -32.3854,-4.71323 -60.52241,4.95802 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 233.44322,185.11212 c 0,0 31.821,-12.06116 59.92895,-0.84259 0,0 5.30851,-21.50621 -6.58253,-36.89222 0,0 -29.19661,-3.61299 -53.50747,2.08917 0,0 5.80276,13.22961 0.16114,35.64564 z",
    id: "path4700",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 287.7987,144.53652 c 0,0 4.89974,-18.57328 -8.36683,-32.16871 0,0 -19.98237,-2.9787 -44.18004,1.09844 0,0 7.93984,16.59196 0.75942,32.60131 0,0 25.84514,-10.24209 51.78755,-1.53104 z",
    id: "path4702",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4704",
    d: "m 251.83351,102.96248 10.09274,0.0289 7.48834,-11.62577 -24.72183,-0.05693 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4706",
    d: "m 254.30466,80.038101 v 7.89424 h 5.2423 v -7.853924 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4708",
    d: "m 255.30551,228.5235 v 9.49437 h 6.29304 v -9.51431 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 146.84255,143.59541 c 0,0 8.71933,12.9935 3.07743,39.72135 0,0 35.95071,-16.51874 65.76538,-1.42473 0,0 6.72467,-27.4687 -8.32041,-43.25465 0,0 -32.3854,-4.71323 -60.5224,4.95803 z",
    id: "path4710",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4712",
    d: "m 151.74374,138.19877 c 0,0 32.49792,-12.06116 60.60588,-0.8426 0,0 2.98113,-20.15554 -7.25946,-36.89221 0,0 -29.19661,-3.612992 -53.50747,2.08917 0,0 5.80276,13.22961 0.16115,35.64564 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4714",
    d: "m 206.09922,98.222737 c 0,0 4.89974,-18.573281 -8.36682,-32.168711 0,0 -19.64386,-2.978698 -43.84154,1.098436 0,0 7.93984,16.59196 0.75943,32.60131 0,0 25.50663,-10.24208 51.44903,-1.531035 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 172.05217,62.254905 10.09274,0.02895 7.48834,-11.625766 -24.72183,-0.05693 z",
    id: "path4716",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 174.52331,39.33052 v 7.89426 h 5.24231 v -7.853944 z",
    id: "path4718",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4720",
    d: "m 64.823957,180.21227 c 0,0 7.985964,15.98355 3.077432,40.96249 0,0 35.950721,-16.51872 65.765391,-1.42473 0,0 6.72467,-28.70984 -8.32042,-44.4958 0,0 -27.757872,-7.10676 -60.522403,4.95804 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 3.52208233,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 69.725152,174.89969 c 0,0 31.031098,-12.06117 59.139058,-0.8426 0,0 6.88822,-21.84471 -5.79263,-36.89222 0,0 -28.079582,-4.72998 -53.507479,2.08917 0,0 5.802756,13.22961 0.161147,35.64565 z",
    id: "path4722",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 124.08064,134.66258 c 0,0 4.89974,-18.57327 -8.36683,-32.1687 0,0 -19.305462,-2.978713 -43.503129,1.09843 0,0 7.93984,16.59194 0.759428,32.60131 0,0 25.168222,-10.24209 51.110631,-1.53104 z",
    id: "path4724",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4726",
    d: "m 88.115448,92.750039 10.092743,0.02895 7.488339,-11.625766 -24.721841,-0.05693 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4728",
    d: "m 90.586588,69.825654 v 7.89426 h 5.24231 V 69.86597 Z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 92.149728,217.46592 v 9.49436 h 6.293043 v -9.5143 z",
    id: "path4730",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4732",
    d: "m 175.25813,233.68114 v 16.13557 h 6.29305 V 233.6612 Z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4734",
    d: "m 145.47579,187.58999 c 0,0 6.73509,20.57989 1.0932,47.30772 0,0 36.71081,-13.04027 75.72129,-2.62882 0,0 4.96209,-27.99953 -10.01863,-47.87482 0,0 -29.45996,-10.68483 -66.79586,3.19592 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4736",
    d: "m 25.096606,215.53587 10.481813,12.28908 c 0,0 -9.976371,-1.67868 -13.505883,4.0538 0,0 -2.87923,6.43155 -9.265103,7.40392 l -9.6505053,-9.93968 c 0,0 6.6781583,-1.36766 9.6266713,-6.97021 0,0 3.086406,-7.33127 12.313007,-6.83691 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.31323481px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4636",
    style: {
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 4.82476997,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 91.252508,286.68452 c -11.692347,-0.22802 -21.057423,-9.59308 -21.057423,-21.14548 0,-11.55238 9.365076,-20.91749 21.057423,-21.07449 l 164.713032,-0.0377 c 13.08854,0.27666 22.45361,9.6418 22.45361,21.19417 0,11.5524 -9.36507,20.91749 -22.61321,21.21831 z",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "csccscc"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccc",
    "inkscapeConnector-curvature": 0,
    id: "path4738",
    d: "m 364.96829,213.54419 c -25.62898,-12.00862 -55.35555,-8.40307 -55.35555,-8.40307 0,0 13.08854,-21.61548 -6.27028,-65.21718 0,0 38.09215,32.51699 61.62583,73.62025 z",
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 4.82476997,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4740",
    d: "m 292.95859,243.90061 7.46065,5.25111 16.86324,-4.27962 7.28058,-5.11559 9.82265,1.07984 40.79112,-10.45235 -0.53555,-2.65148 z",
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.5531075px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargo);
export default __webpack_public_path__ + "static/media/cargo.5dc675f67a56abeab9754b67ade24521.svg";
export { ForwardRef as ReactComponent };